import { useEffect, useState } from "react";
import Header from "../components/dashboard/Header";
import { useLocationOptions } from "../components/AvailabilityPanel";
import { ProgrammingCalendar } from "../components/programming/ProgrammingCalendar";

export default function Programming() {
  const locations = useLocationOptions();
  const [location, setLocation] = useState(() => new URLSearchParams(window.location.search).get("location") || "");
  useEffect(() => { if (!location && locations.length) setLocation(locations[0]); }, [locations, location]);
  return (
    <div className="min-h-screen bg-brand-page relative z-10">
      <Header />
      <main className="max-w-[1280px] mx-auto px-6 lg:px-12 py-10 space-y-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-brand-tertiary">Locations &amp; Members</p>
            <h1 className="font-serif text-4xl lg:text-5xl font-light tracking-tight text-brand-ink mt-2">Events &amp; Programming</h1>
            <p className="text-sm text-brand-muted mt-1">Each location's member events. Newsletters fill from this calendar.</p>
          </div>
          <select value={location} onChange={(e) => setLocation(e.target.value)} data-testid="prog-location" className="border border-brand-border rounded-md px-3 py-2 text-sm bg-brand-surface text-brand-ink">
            {locations.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        {location && <ProgrammingCalendar key={location} location={location} />}
      </main>
    </div>
  );
}
